import DistanceNumber from './DistanceNumber';

export default DistanceNumber;
export { DistanceNumber };
